exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scrollable.more-wrapper {\n\tpadding: 71px 0 108px;\n}\n\n.more-wrapper iframe {\n  border: none;\n}\n\n.more-wrapper .more-header {\n\theight: 15%;\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-flow: column;\n            flex-flow: column;\n    -ms-flex-pack: distribute;\n        justify-content: space-around;\n    text-align: center;\n}\n\n.more-wrapper .more-body {\n\theight: 85%;\n}\n\n.more-wrapper .more-body iframe {\n  height: 100%;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/rubylover/Work/new_vin_photo/site/web/src/app/more/more.component.css
// module id = ../../../../../src/app/more/more.component.css
// module chunks = main